import React from 'react';
import scrollama from 'scrollama';
import Tilt from 'react-tilt';
import Signature from './Signature';
import { IconWhatsapp, IconInstagram } from '../assets';
import logoImage from '../assets/logo.svg';
import headerImage from '../assets/header.png';
import penImage from '../assets/francisco_fade_bw.png';
import studyImage from '../assets/study.png';

export const mobileAndTabletcheck = () => {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw(n|u)|c55\/|capi|ccwa|cdm|cell|chtm|cldc|cmd|co(mp|nd)|craw|da(it|ll|ng)|dbte|dcs|devi|dica|dmob|do(c|p)o|ds(12|d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(|_)|g1 u|g560|gene|gf5|gmo|go(\.w|od)|gr(ad|un)|haie|hcit|hd(m|p|t)|hei|hi(pt|ta)|hp( i|ip)|hsc|ht(c(| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i(20|go|ma)|i230|iac( ||\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|[a-w])|libw|lynx|m1w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|mcr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|([1-8]|c))|phil|pire|pl(ay|uc)|pn2|po(ck|rt|se)|prox|psio|ptg|qaa|qc(07|12|21|32|60|[2-7]|i)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h|oo|p)|sdk\/|se(c(|0|1)|47|mc|nd|ri)|sgh|shar|sie(|m)|sk0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h|v|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl|tdg|tel(i|m)|tim|tmo|to(pl|sh)|ts(70|m|m3|m5)|tx9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas|your|zeto|zte/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

export const isMobileOrTablet = mobileAndTabletcheck();

export const Nav = ({handleSection, phone, handleMenu}) => (
	<div className="header__nav traf">
		<div className="inner__section">
			<a href="/">
				<img className="traf" src={logoImage} alt="Logo"/>
			</a>
			<div onClick={handleMenu} className="right hamburguer hamburguer__menu">
				<div className="bar1"></div>
				<div className="bar2"></div>
				<div className="bar3"></div>
			</div>
			<div className="wp-menu traf">
				<ul className="traf">
					<li className="active"><span data-to=".section__header" onClick={handleSection}>Inicio</span></li>
					<li><span data-to=".study" onClick={handleSection}>Estudio</span></li>
					<li><span data-to=".wp-section-areas" onClick={handleSection}>Áreas de práctica</span></li>
					<li><span data-to=".contact" onClick={handleSection}>Contacto</span></li>
					{phone && (<li className="call-phone"><a href={`tel:${phone}`}><i className="icon-phone"></i><strong>{phone}</strong></a></li>)}
					{phone && (<li className="whatsapp-phone"><a target="_blank" rel="noopener noreferrer" href={`https://wa.me/${phone}`}><i><IconWhatsapp /></i><strong>Whatsapp</strong></a></li>)}
					{phone && (<li className="instagram-link"><a target="_blank" rel="noopener noreferrer" href={`https://www.instagram.com/estudiopineda/?hl=es-la`}><i><IconInstagram /></i><strong>Instagram</strong></a></li>)}
				</ul>
			</div>
		</div>
	</div>
);

export class Header extends React.Component {
	static defaultProps = {
		title: 'Soluciones concretas coherentes con su realidad',
		subtitle: 'Todo parte con una conversación, escríbanos y encontremos una solución a su problema.',
		image: headerImage
	};
	componentDidMount() {
		if (isMobileOrTablet) return;
		const scroller = scrollama();
		scroller
		.setup({ step: '.section__header', progress: true, offset: 0, threshold: 2})
		.onStepProgress(({progress}) => {
			this._img.style.transform = `translateY(${progress*30}%)`;
		});
	}
	render(){
		var bgImage = null;
		var { handleSection, title, subtitle, image, phone } = this.props;
		if ((typeof image === 'string' || image instanceof String) && image.length === 36){
			bgImage = `https://outlier-spa.github.io/EstudioPinedaWeb/${image}.png`;
		} else {
			bgImage = image;
		}
		return (
			<section className="section__header gradient__section luxy-el" data-speed-y="-5">
				<div className="inner__section h100">
					<div className="in_view_animate wp-header-image">
						<div ref={r => this._img = r} className="bg-cover header-image" style={{backgroundImage: `url(${bgImage})`}}></div>
					</div>
					<div className="header__info in_view_animate">
						<img src={logoImage} alt="Logo"/>
						<h1 className="">{title}</h1>
						<p className="">{subtitle}</p>
						<div className="button-container">
							<button data-to=".contact" onClick={handleSection} className="fill-animation traf in_view_animate">
								<span>Contáctenos</span>
							</button>
							{phone && (
								<a href={`https://wa.me/${phone}`} target="_blank" rel="noopener noreferrer" className="button whatsapp-contact fill-animation-green fill-animation traf in_view_animate">
									<i><IconWhatsapp /></i>
									<span>Whatsapp</span>
								</a>
							)}
						<a href={'https://www.instagram.com/estudiopineda/?hl=es-la'} target='_blank'className="button whatsapp-contact fill-animation-pink fill-animation traf in_view_animate">
								<i className='margin'><IconInstagram /></i>
								<span>Instagram</span>
						</a>
						</div>
					
					</div>
				</div>
			</section>
		);
	}
}

export class Where extends React.Component{
	static defaultProps = {
		title:'¿Dónde estamos?',
		description: 'Te ayudamos a encontrarnos con este video que grabamos desde la esquina de Manuel Bulnes con Antonio Varas. ',
		address:'Estamos en General Aldunate 719, Oficina 807 Temuco, Región de la Araucanía'
	}
	render(){
		var {title, description, address} = this.props;
		return(
			<section className="where">
				<div className="inner__section">
					<div className="flex center-childs">
					<div className="flex1">
							<div className="wp_slider">
							<iframe className='about_image' height="340" src="https://youtube.com/embed/71tbOgpitZI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
							</div>
						</div>
						
						<div className="separation"></div>
						<div className="flex1">
							<div>
								<h2 className="section__title in_view_animate">{title}</h2>
								<p className="in_view_animate">
									{description}
								</p>
								<div style={{marginTop:'16px'}}>
								<i  className="icon-location"></i> {address}
							</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		)
	}

}

export class Vision extends React.Component{
	static defaultProps = {
		title: 'Visión',
		description: 'El Derecho cumple una labor evidentemente social, teniendo un impacto no sólo en la persona individualmente considerada sino en la sociedad en general, en su familia, amigos, etc., Es por ello que nuestro estudio aboga por soluciones concretas, reales y coherentes con la realidad económica y jurídica de nuestros representados. No tememos decir las cosas de frente cuando derechamente no existen formas de salvar el problema planteado. Jamás asesoraremos y cobraremos sin una real necesidad jurídica.',
		name: 'Francisco Pineda Peña',
		position: 'Abogado fundador',
	};
	render(){
		var { title, description, name, position } = this.props;
		return (
			<section className="vision gradient__section">
				<div className="inner__section_vision">
					<img ref={r => this._img = r} className="pen"  src={penImage} alt="pen"/>
					<h2 className="section__title inverse in_view_animate">{title}</h2>
					<p className="in_view_animate">{description}</p>
					<Signature name={name} position={position} />
				</div>
			</section>
		);
	}
}


export const Study = ({image, title, description, text1, text2}) => {
	var bgImage =
    (typeof image === 'string' || image instanceof String) &&
    image.length === 36
      ? `https://outlier-spa.github.io/EstudioPinedaWeb/${image}.png`
      : image || studyImage;
	return (
		<section className="study image__section">
			<div className="inner__section">
				<div className="flex center-childs">
					<div className="flex1">
						<Tilt options={{scale: 1, max: 10 }}  className="wp-image">
							<img src={bgImage} alt="Estudio"/>
							<div className="image-text in_view_animate">
								<h4 className="section__title small">{text1}</h4>
								<h2>{text2}</h2>
							</div>
						</Tilt>
					</div>
					<div className="separation"></div>
					<div className="flex1">
						<div>
							<h2 className="section__title in_view_animate">{title}</h2>
							<p className="in_view_animate">{description}</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}

Study.defaultProps = {
	title: 'El Estudio',
	description: 'FPP es un estudio jurídico regional que nace en el año 2016, apostando a entregar soluciones integrales y oportunas a las diversas problemáticas jurídicas actuales. El Estudio tiene como base el trato cercano y directo en la relación abogado cliente, esto a fin de lograr que sus necesidades jurídicas sean satisfechas en forma rápida y plena. La asesoría se brindará de forma inmediata y con accesibilidad, dependiendo del lugar de ubicación del cliente.',
	text1: 'Nuestras principales características',
	text2: 'Compromiso, ética y responsabilidad'
}


export const Contact = ({title, phone, text, sent, onSendMessage}) => (
	<section className="contact">
		<div className="inner__section">
			<div className="wp-contact">
				<div className="contact_info left in_view_animate">
					<h3 className="section__title small">{title}</h3>
					<h2 className="in_view_animate">{text}</h2>
					{phone && (
						<>
							<p>o iniciemos una conversación por whatsapp</p>
							<a href={`https://wa.me/${phone}`} target="_blank" rel="noopener noreferrer">
								<i><IconWhatsapp /></i>
								<span>Whatsapp</span>
							</a>
						</>
					)}
				</div>
				<div className="contact_form right">
					<form action="void(0)">
						<input id="contact-name" className="field" type="text" placeholder="Nombre" />
						<input id="contact-email" className="field" type="text" placeholder="Email" />
						<input id="contact-subject" className="field" type="text" placeholder="Asunto" />
						<textarea id="contact-content" className="field" rows="10" placeholder="Contenido del mensaje"></textarea>
						{ sent ? <p>Correo enviado, pronto nos pondremos en contacto!</p> : <button onClick={onSendMessage}>Enviar</button>}
					</form>
				</div>
			</div>
		</div>
	</section>
);

Contact.defaultProps = {
	title: 'Contacto',
	text: 'Ingrese sus datos y lo contactaremos en breve',
	sent: false
};

export class Location extends React.Component {
	static defaultProps = {
		phone: '+56 9 8808 1089',
		email: 'contacto@estudiopineda.cl',
		address: 'Claro solar 780, Oficina 404 Temuco, Región de la Araucanía'
	};
	render(){
		var { phone, email, address } = this.props;
		return (
			<section className="location">
				<div className="inner__section">
					<div className="wp-location">
						<div className="links left in_view_animate">
							<h2>Puedes encontrarnos aquí</h2>
							<div>
								<a href={`tel:${phone.replace(' ', '')}`}><i className="icon-contact"></i> {phone}</a>
							</div>
							<div>
								<a href={`mailto:${email}`}><i className="icon-mail"></i> {email}</a>
							</div>
							<div>
								<a href={`http://maps.google.com/?q=${address}`} target="_blank" rel="noopener noreferrer">
									<i className="icon-location"></i> {address}
								</a>
							</div>
						</div>
						<div className="map right">
							<iframe src={`https://maps.google.com/?q=${address}&z=16&output=embed`} width="100%" height="100%" frameBorder="0" style={{border: 0}} allowFullScreen=""></iframe>
						</div>
					</div>
				</div>
			</section>
		);
	}
}

export const Footer = () => (
	<footer>
		developed by <a target="_blank" className="traf" rel="noopener noreferrer" href="http://outlier.cl">Outlier SpA</a> 2021, all rights reserved
	</footer>
);
